module.exports = __webpack_public_path__ + "img/HZ-T1463.79ce5c75.jpg";